import { Box, Typography } from "@mui/material";
import { useFormContext } from "react-hook-form";

export const FooterTableSilicagel = ({ columns, rows }: any) => {
  const { setValue } = useFormContext();
  const totalRow1 = rows.find((row: any) => row.id === 1);
  const totalRow2 = rows.find((row: any) => row.id === 2);

  // Calcular las diferencias para cada trampa
  const waterRetainedValues = columns
    .filter((column: any) => column.field.startsWith("trampa_"))
    .map((column: any) => {
      const valueBeforeExp = parseFloat(totalRow1?.[column.field]) || 0;
      const valueAfterExp = parseFloat(totalRow2?.[column.field]) || 0;
      return valueAfterExp - valueBeforeExp;
    });

  // Calcular la sumatoria de las diferencias
  const totalWaterRetained = waterRetainedValues.reduce(
    (acc: number, curr: number) => acc + curr,
    0
  );

  return (
    <Box>
      {/* Fila de Agua retenida (g/ml) */}
      <Box
        sx={{
          display: "flex",
          backgroundColor: "#f5f5f5",
          borderTop: "1px solid #ddd",
          padding: "8px 16px",
        }}
      >
        {columns.map((column: any, index: any) => {
          const columnFlex = column.flex || 1;
          
          setValue("waterRetainedValues", waterRetainedValues);  

          if (index === 0) {
            return (
              <Typography
                key={index}
                variant="body2"
                sx={{
                  flex: columnFlex,
                  fontWeight: "bold",
                  textAlign: column.align || "left",
                }}
              >
                Agua retenida (g/ml)
              </Typography>
            );
          } else if (column.field.startsWith("trampa_")) {
            const waterRetained = waterRetainedValues[index - 1] || 0;

            return (
              <Typography
                key={index}
                variant="body2"
                sx={{
                  flex: columnFlex,
                  padding: "0 10px",
                  textAlign: column.align || "center",
                  borderLeft: "1px solid #ddd",
                }}
              >
                {waterRetained.toFixed(2)}
              </Typography>
            );
          } else {
            return (
              <Typography
                key={index}
                variant="body2"
                sx={{
                  flex: columnFlex,
                  textAlign: column.align || "center",
                }}
              ></Typography>
            );
          }
        })}
      </Box>

      <Box
        sx={{
          display: "flex",
          backgroundColor: "#f5f5f5",
          borderTop: "1px solid #ddd",
          padding: "8px 16px",
        }}
      >
        {columns.map((column: any, index: any) => {
          const columnFlex = column.flex || 1;
          if (index === 0) {
            return (
              <Typography
                key={index}
                variant="body2"
                sx={{
                  flex: columnFlex,
                  fontWeight: "bold",
                  textAlign: column.align || "left",
                }}
              >
                Volumen total de agua retenida en silicagel (ml)
              </Typography>
            );
          }
          if (index === columns.length - 1) {
            return (
              <Typography
                key={index}
                variant="body2"
                sx={{
                  flex: columnFlex,
                  fontWeight: "bold",
                  textAlign: column.align || "center",
                }}
              >
                {totalWaterRetained.toFixed(2)}
              </Typography>
            );
            
          } else {
            setValue("totalWaterRetained", totalWaterRetained.toFixed(2));  
            return (
              <Typography
                key={index}
                variant="body2"
                sx={{
                  flex: columnFlex,
                  textAlign: column.align || "center",
                }}
              ></Typography>
            );
          }
        })}
      </Box>
    </Box>
  );
};
